import { useContext } from 'react';

import { ApplicationContext, IApplicationState } from 'contexts/application/ApplicationContextProvider';

export default function useApplicationContext(): Required<IApplicationState> {
  const context = useContext(ApplicationContext);

  if (!context || !context.application) {
    throw new Error('useApplicationContext must be used within a ApplicationContextProvider');
  }

  return useContext(ApplicationContext) as Required<IApplicationState>;
}
